// Gravity Forms Post Render 
jQuery(document).on('gform_post_render', function(event, form_id, current_page) {

   jQuery('.gform_body input').each(function(i, obj) {

      let current_gf_field = jQuery(this).attr('value');
      
      if (current_gf_field.startsWith('http') && current_gf_field.includes('dataaxleusa.com')) {

          jQuery(this).attr('value', window.location.href);

      }

   });

   let cmsCookie = Cookies.get('CmsCookie');

   let gfEntry = Cookies.get('gfEntry');

   if (cmsCookie) {
      parsedCmsCookie = JSON.parse(cmsCookie);
   }

   // Gravity Form 2, the Web to Lead | Contact Us form
   if (form_id === 2) {

     if (cmsCookie && parsedCmsCookie.IsAuthenticated) {            

         jQuery('#input_2_3').val(parsedCmsCookie.AccountId);

      }   

   }

   // Gravity Form 12, the Seamless Registration form
   if (form_id === 6) {

      if (gfEntry) {

         let gfEntryJSON = JSON.parse(gfEntry);

         let main_or_lp = document.referrer;

         if (main_or_lp.indexOf('/lp/') !== -1) {

            // the landing pages site
            jQuery('#input_6_1').attr('value', gfEntryJSON[3]).attr('readonly', 'true');

        } else {

            // the main site
            jQuery('#input_6_1').attr('value', gfEntryJSON[5]).attr('readonly', 'true'); // not LP

        }

         

      }

   }

   // Gravity Form 7, the Newsletter Sign Up form
   if (form_id === 7) {

      if (jQuery('#gform_wrapper_7').parents('#infogroup-modal').length == 1 ) {
         jQuery('#input_7_2').val('true');
      }
   }

   // Gravity Form 12, the Seamless Registration form
   if (form_id === 12) {

      if (gfEntry) {

         let gfEntryJSON = JSON.parse(gfEntry);

         full_name = gfEntryJSON[1];

         let split_full_name = full_name.split(' ', 2);

         let last_name;

         if (split_full_name.length === 2) {
            
            last_name = split_full_name[1];

         } else {

            last_name = 'No Last Name Given';

         }

         jQuery('#input_12_1').attr('value', split_full_name[0]);
         jQuery('#input_12_3').attr('value', last_name);
         jQuery('#input_12_4').attr('value', split_full_name[0] + ' ' + last_name);
         jQuery('#input_12_5').attr('value', gfEntryJSON[4]);
         //Main Seamless registration email autofill
         jQuery('#input_12_6').attr('value', gfEntryJSON[5]).attr('readonly', 'true');
         //Add class to label if email value found
         if(jQuery('#input_12_6').val()){
            jQuery('#input_12_6').closest('li').find('label').addClass('active-label-value');
         }

      }

   }

    // the main W2C forms that lead to seamless registration
    if ((form_id === 3) || (form_id === 11)) {

      jQuery('#input_3_36, #input_11_36').attr('value', window.navigator.userAgent);

   }

});

jQuery(document).ready(function() {

   // force cursor placement on input masked phone field only when empty of characters
   var maskedPhones = document.querySelectorAll('.gfield .ginput_container_phone input');

   for (i = 0; i < maskedPhones.length; ++i) {

      maskedPhones[i].addEventListener('mouseup', function(e) {

            if ( e.currentTarget.value.replace(/\(|\)|_|-|\./g,'').trim() == '' ) {

               e.currentTarget.setSelectionRange(0,0);

            }

       });

   }

   // Force cursor placement on input masked email field only when empty
   // var maskedEmails = document.querySelectorAll('.gfield .ginput_container_email input');

   // for (var i = 0; i < maskedEmails.length; ++i) {

   //    maskedEmails[i].addEventListener('mouseup', function(e) {

   //       let is_valid_email_format = validator.isEmail(e.currentTarget.value);

   //       if (!is_valid_email_format) {

   //             e.currentTarget.setSelectionRange(0,0);

   //       }

   //    });

   // }

   // insert the show/hide eye icons after the .password-eye input
   jQuery('<i class="show-password password-eye-icon fa fa-eye" aria-hidden="true"></i><i class="hide-password password-eye-icon fa fa-eye-slash" aria-hidden="true"></i>').insertAfter('.password-eye input');


   // show/hide the masked password when the eye icons are clicked
   jQuery('.password-eye-icon').click(function() {

      if (jQuery(this).hasClass('show-password')) {

         jQuery('.password-eye input').attr('type', 'text');

         jQuery(this).hide();

         jQuery('.hide-password').show();

      } else if (jQuery(this).hasClass('hide-password')) {

         jQuery('.password-eye input').attr('type', 'password');

         jQuery(this).hide();

         jQuery('.show-password').show();

      }

   });

});

// jQuery(document).on('click', '.gform_button', function() {

//     let formTarget = jQuery(this).parents().eq(1).prop('target');

//     if (!formTarget.includes('gform_ajax')) {
//         jQuery('<img id="gform_ajax_spinner_9" class="gform_ajax_spinner" src="https://' + window.location.hostname + '/wp-content/plugins/gravityforms/images/spinner.svg" alt="">').insertAfter(this);
//     }

//     jQuery(this).val('SENDING...').attr('style', 'pointer-events:none!important');

// });